module.exports = __webpack_public_path__ + "img/Terengganu.73f12032.png";